// 外签、3C 数码坐班、小红书图文
export const SIGN_TYPE_1 = '外签'
export const SIGN_TYPE_2 = '3C数码坐班'
export const SIGN_TYPE_3 = '小红书图文'
export const MapSignType = {
  [SIGN_TYPE_1]: { label: '外签', type: 'warn' },
  [SIGN_TYPE_2]: { label: '3C数码坐班', type: 'success' },
  [SIGN_TYPE_3]: { label: '小红书图文', type: 'info' }
}
